import styles from './Nowrap.module.css';

type IntrinsicSpanProps = JSX.IntrinsicElements['span'];

/**
 * Disables text wrapping for child content.
 *
 * @see https://corgi-x.tfd.engineering/components/nowrap
 */
export function Nowrap({ children, ...props }: IntrinsicSpanProps) {
  return (
    <span className={styles.nowrap} {...props}>
      {children}
    </span>
  );
}
